import { DetailedOfflinePurchase, GQL_ID } from '@@types'
import { gql, QueryHookOptions, useQuery } from '@apollo/client'


type Query = {
  singleOfflinePurchase: DetailedOfflinePurchase
}

type Variables = {
  id: GQL_ID
  style?: string
}


export const GQL_QUERY_OFFLINE_PURCHASE = gql`
  query singleOfflinePurchase ($id: ID!, $style: String) {
    singleOfflinePurchase(id: $id) {
      id
      created_at
      placed_at
      placedAt
      status
      total
      saledCost
      customerFinalCost
      deliveryCost
      address
      comment
      payment_status
      payment_type
      assembled_total
      totalCashback
      totalDiscount
      deliveryType
      reviewInvite
      positions {
        id
        xid
        barCode
        name
        count
        price
        basePrice
        discount
        total
        discounts {
          code
          name
          type
          positionId
          xid
          totalDiscount
          amount
          cardNumber
        }
        product {
          id
          xid
          name
          slug
          preview(style: $style) {
            url
          }
          price_type
          count_multiplier
        }
      }
      discounts {
        code
        name
        type
        positionId
        xid
        totalDiscount
        amount
        cardNumber
      }
    }
  }
`

export const useFetchSingleOfflinePurchase = ({
  id,
  ...rest
}: { id: GQL_ID } & Omit<QueryHookOptions<Query, Variables>, 'variables'>) => {
  const { loading, error, data, refetch } = useQuery<Query, Variables>(GQL_QUERY_OFFLINE_PURCHASE, {
    variables: { id },
    ...rest
  })

  const purchase = data?.singleOfflinePurchase

  return {
    purchase,
    data,
    loading,
    error,
    refetch
  }
}